<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu">
            <div slot="header">
              <strong v-if="thai_student==1">หัวข้อการประเมิน</strong>
              <strong v-else-if="thai_student==0">Learning Outcomes </strong>
              <strong v-else> </strong>
              <div style="float:right;"
              >
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                                    {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <!--            <b-form-group label-cols-sm="1"  label-align-sm="right" label-for="nested-street">-->
            <b-form-group label-cols-sm="1" label-align-sm="right" label-for="nested-street">

              <b-row>{{ question.QUESTION_NAME }}</b-row>
              <br>
              <div v-for="item1 in item1s">
                <input type="radio" id="1" value="1" v-model="radio10" v-on:change="changeRadio(radio10)"/>
                &nbsp;&nbsp;{{ item1.BYTEDES }}
              </div>
              <br>

              <div v-for="item2 in item2s">
                <div v-if="item2.BYTECODE==1">
                  <input type="radio" id="2" value="2" v-model="radio10" v-on:change="changeRadio(radio10)"/>
                  &nbsp;&nbsp;{{ item2.BYTEDES }} <strong><font color="red">{{txt_and}}</font></strong>
                </div>
                <div v-else-if="item2.BYTECODE==2">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item2.BYTEDES }}
                </div>
                <div v-else>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item2.BYTEDES }} <strong><font
                  color="red">{{txt_and}}</font></strong>
                </div>
              </div>
              <br>

              <div v-for="item3 in item3s">
                <div v-if="item3.BYTECODE==1">
                  <input type="radio" id="3" value="3" v-model="radio10" v-on:change="changeRadio(radio10)"/>
                  &nbsp;&nbsp;{{ item3.BYTEDES }} <strong><font
                  color="red">{{txt_and}}</font></strong>
                </div>
                <div v-else-if="item3.BYTECODE==3">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item3.BYTEDES }}
                </div>
                <div v-else>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item3.BYTEDES }} <strong><font color="red">{{txt_and}}</font></strong>
                </div>
              </div>
              <br>

              <div v-for="item4 in item4s">
                <div v-if="item4.BYTECODE==1">
                  <input type="radio" id="4" value="4" v-model="radio10" v-on:change="changeRadio(radio10)"/>
                  &nbsp;&nbsp;{{ item4.BYTEDES }} <strong><font
                  color="red">{{txt_and}}</font></strong>
                </div>
                <div v-else-if="item4.BYTECODE==4">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item4.BYTEDES }}
                </div>
                <div v-else>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item4.BYTEDES }} <strong><font color="red">{{txt_and}}</font></strong>
                </div>
              </div>
              <br>

              <div v-for="item5 in item5s">
                <div v-if="item5.BYTECODE==1">
                  <input type="radio" id="5" value="5" v-model="radio10" v-on:change="changeRadio(radio10)"/>
                  &nbsp;&nbsp;{{ item5.BYTEDES }} <strong><font
                  color="red">{{txt_and}}</font></strong>
                </div>
                <div v-else-if="item5.BYTECODE==5">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item5.BYTEDES }}
                </div>
                <div v-else>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item5.BYTEDES }} <strong><font color="red">{{txt_and}}</font></strong>
                </div>
              </div>
              <br>

            </b-form-group>
            <div slot="footer" class="text-center">
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>

              <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!-- <div slot="footer" class="text-center">
        <b-button type="submit" size="sm" variant="primary" @click="onSubmit">
          <i class="fa fa-dot-circle-o"></i> Submit
        </b-button>

        <b-button type="reset" size="sm" variant="danger" @click="onReset">
          <i class="fa fa-ban"></i> Reset
        </b-button>
      </div> -->

      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal
      v-if="thai_student==1"
      title="คุณกรอกข้อมูลไม่ครบถ้วน"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal
      v-if="thai_student==0"
      title="You didn’t fill your information completely"
      class="modal-danger"
      v-model="dangerModal"
      @ok="dangerModal = false"
      ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreatePart10_5",
  data() {
    return {
      student: {},
      current_number: "",
      std_id: "",
      thai_student: "",
      qid: 0,
      current_erorrtxt: "",
      dangerModal: false,
      radio10: "",
      item1s: [],
      item2s: [],
      item3s: [],
      item4s: [],
      item5s: [],
      question: [],
      txt_and:"",
      actionUpdate: false,
      actionUpdateRegis: false,
      /*  dataIndb: false,
        radio: [],
        question_id: "",
        ans: "",
        countupdate: 0,
        countinsert: 0,
        length: 0,
        q_1: 0,
        q_7: 0,*/
    };
  },
  computed: {
    state() {
      // console.log("xxxxx=", Boolean(this.value));
      return Boolean(this.value);
    }
  },
  methods: {
    changeRadio(e) {
      // console.log(e)
      this.radio10 = e;
    },
    setStudent(i) {
      // console.log("i==", i)
      var question = {};
      question.std_id = this.$store.state.user.studentid;
      question.qn_year = this.$store.state.user.year;
      question.question_id = i;
      question.ans = this.radio[i];
      return question;
    },
    getCurrentStudent(studentid, qid) {
      api
        .getPart10(studentid, qid)
        .then(res => {
          // console.log("res==", res);
          if (res.data.code==200 && res.data.data.length==1) {
            this.radio10=res.data.data[0].ANS
            this.actionUpdate = true;
          }else{
            this.actionUpdate = false;
          }
        })
        .catch(err => {
          this.actionUpdate = false;
          console.log("getStudentGeneral", err.toString());
          // this.$router.push("Logout");
        });
      return this.actionUpdate;
    },
    getErrorTxt: function () {
      this.current_erorrtxt = "";
      var numEror = 0;
      if ((this.radio10 == 0) || (this.radio10 == '') || (this.radio10 == null)) {
        numEror = 1;
      } else {
        numEror = 0;
      }
      if (numEror == 0) {
        this.current_erorrtxt = "";
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
        if (this.thai_student == 1) {
          this.current_erorrtxt = "กรอกข้อมูลไม่ครบ";
        } else {
          this.current_erorrtxt = "You didn’t fill your information completely";
        }
      }
      return numEror;
    },
    nextPart() {
      this.$router.push("/dashboard");
    },
    getQuestionnaire(questionnaireid, thaistudent, start) {
      api
        .getQuestionPart10(questionnaireid, thaistudent, start)
        .then(res => {
            // console.log("thaistudent==",questionnaireid);
            // console.log("thaistudent==",thaistudent);
            // console.log("res==",res);
            this.question = res.data.data[0];
          }
        )
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getAnsLoop(id, th, code) {
      api
        .getAnsLoop(id, th, code)
        .then(res => {
            this.item5s = res.data.data;
            for (var i = 0; i <= 3; i++) {
              var tempData = [];
              var m =i;
              for ( var j = 0; j <= m ; j++) {
                tempData.push(res.data.data[j])
              }
              if (i==0){
                this.item1s = tempData;
              }else if (i==1){
                this.item2s = tempData;
              }else if (i==2){
                this.item3s = tempData;
              }else if (i==3){
                this.item4s = tempData;
              }
            }
          }
        )
        .catch(err => {
          console.log("275 getQuestionBySection", err.toString());
        });

    },
    getAns(id, th) {
      api
        .getAnsPart10(id, th)
        .then(res => {
            this.items = res.data.data;
          }
        )
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
  getCurrentUserQuestion(studentid) {
      api
        .getStudentUserQuestionById(studentid)
        .then(res => {
          // console.log("getCurrentUserQuestion==", res.data.data[0].QUESTIONNAIRE_1);
          if (res.data.data.length ==1) {
            this.q_1 = res.data.data[0].QUESTIONNAIRE_1;
            this.actionUpdateRegis = true;
            if (this.q_1!=1){
              if (this.thai_student == 1) {
                this.current_erorrtxt = "กลับไปกรอกข้อมูล แบบสอบถามภาวะการมีงานทำของบัณฑิต ก่อน";
              } else {
                this.current_erorrtxt = "Back to fill your Graduate Employability Survey";
              }
              this.dangerModal = true;
            }
          } else {

            this.actionUpdateRegis = false;
            this.q_1 = 0;
          }
        })
        .catch(err => {
          this.actionUpdateRegis = false;
          console.log("getStudentUserQuestionById error", err.toString());
        });
    },
    onUpdateData(student) {
      api
        .updatePart10(student)
        .then(res => {
          // console.log("res==",res)
          if (res.data.code==200){
            this.$router.push("part10_6");
          }else{
            this.$router.push("part10");
          }
        })
        .catch(err => {
          console.log("onUpdateData", err.toString());
          // this.$router.push("login");
        });
    },
    onReset() {
      this.radio10 = "";
    },
    onSubmit: function () {
      var error = this.getErrorTxt(this.radio10);
      // console.log("nerror=", error);
      if (error == 0) {
        var student = {};
        student.std_id = this.$store.state.user.studentid;
        // console.log("x==",this.$store.state.user)
        student.qn_year = this.$store.state.user.year;
        student.question_id = this.qid;
        student.ans=this.radio10
        student.columname = "QN_"+student.question_id;
        this.onUpdateData(student);
      }
    }
  },
  created() {

    if (this.$store.state.user.token == null || this.$store.state.user == null) {
      this.$router.push("/logout");
    } else {
      this.std_id = this.$store.state.user.studentid;
      this.actionUpdateRegis=this.getCurrentUserQuestion(this.std_id);

      if ((this.$store.state.user != null) && (this.$store.state.user != undefined) && (this.$store.state.user != '')) {

        this.thai_student = this.$store.state.user.thaistudent;
        if (this.thai_student==1){
          this.txt_and=" และ";
        }else{
          this.txt_and=" and";
        }
        this.qid = 205;
        this.actionUpdate = this.getCurrentStudent(this.std_id, this.qid);
        this.getQuestionnaire(10, this.thai_student, this.qid);
        this.getAnsLoop(this.qid, this.thai_student, 5);
        api.onSetHeader();
      } else {
        this.$router.push("/logout");
      }
    }

  }
};
</script>
<style>

</style>
